<template>
    <div>
        <b-table
            bordered
            striped
            responsive
            :items="showSteps"
            :fields="activeStepFields"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded">
            <template #cell(action)="{item}">
                <div v-if="item.showButton" class="text-center">
                    <ProcessingButton :processing="formLoading" :label="$t('set_as_active_step')" @click="updateForm(item.id)"/>
                </div>
                <div v-else>
                    {{$t(item.status)}}
                </div>
            </template>
        </b-table>


    </div>
</template>

<script>
import ApprovalStepService from "@/services/ApprovalStepService";
import ProcessingButton from "@/components/elements/ProcessingButton.vue";

export default {
    components: {ProcessingButton},

    props: {
        stepData:  {
            type:Array || null
        },
        activeStepId: {
            type: Number
        }
    },
    data() {
        return {
            formLoading: false,
            form: {
                active_step: null,
            },
            options: [],
            activeStepFields:[
                {
                    key: 'step_name',
                    label: this.$t('steps'),
                },
                {
                    key: 'action',
                    label: this.$t('action'),
                },
            ]
        }
    },
    computed:{
      sortedOptions(){
          return [...this.stepData].sort((a, b) => a.rank - b.rank)
      },
        showSteps(){
            const activeStep=this.sortedOptions.find(item=>item.active)
            if(!activeStep)return []
            return  this.sortedOptions.map((item,index)=>{
                const isPastStep =activeStep.rank>item.rank
                return {
                    step_name:this.getApproveText(item.rank),
                    id:item.id,
                    showButton:isPastStep,
                    status:isPastStep?undefined:item.status,
                }
            })

        }
    },
    methods: {
        async updateForm(id) {
                ApprovalStepService.setActive(id)
                    .then((response) => {
                        this.formLoading=false;
                        this.$toast.success(this.$t("api." + response.data.message));
                        this.$emit("approvalStepFormSuccess")
                    })
                    .catch((error) => {
                        this.showErrors(error, this.$refs.formModalValidate)
                    })
        },
        getApproveText(rank) {
            if (rank === 1) {
                return this.$t("coordinator_approval");
            }
            if (rank === 2) {
                return this.$t("institute_approval");
            }
            if (rank === 3) {
                return this.$t("advisor_approval");
            }

            return "-";
        },
        // setStep(){
        //     this.options=this.stepData
        //     this.options.sort((a, b) => a.rank - b.rank);
        //     const activeStep=this.options.find(item=>item.active)
        //     if (!activeStep) return
        //     this.options.forEach((item)=>{
        //         if (activeStep.rank > item.rank) {
        //             this.showSteps.push(
        //                 {
        //                     step_name:this.getApproveText(item.rank),
        //                     id:item.id,
        //                     showButton:true
        //                 }
        //             )
        //         }else {
        //             this.showSteps.push(
        //                 {
        //                     step_name:this.getApproveText(item.rank),
        //                     id:item.id,
        //                     status:item.status,
        //                     showButton:false
        //                 }
        //             )
        //         }
        //     })
        // }
    }
}
</script>
